import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-a60126fa")
const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "subheadline text-center" }, "Pool Composition", -1)
const _hoisted_2 = { class: "flex mx-1 my-4" }
const _hoisted_3 = { class: "token-name ml-[12px]" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "composition-data flex p-2" }
const _hoisted_6 = { class: "flex-1 text-left" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "subheadline" }, "Weight", -1)
const _hoisted_8 = { class: "flex-1 text-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "subheadline" }, "Balance", -1)
const _hoisted_10 = { class: "flex-1 text-right" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "subheadline" }, "Value", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BalAsset = _resolveComponent("BalAsset")!

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (token, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: _normalizeClass(["card w-full", {'max-w':_ctx.isDesktop}]),
      key: index
    }, [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_BalAsset, {
          address: token.address,
          size: 48
        }, null, 8, ["address"]),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.symbolFor(token.address)), 1),
        _createElementVNode("img", {
          src: _ctx.arrow,
          class: "ml-[12px]"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createTextVNode(" " + _toDisplayString(_ctx.weightFor(token.address)), 1)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.balanceFor(token.address)), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString(_ctx.fiatValueFor(token.address)), 1)
        ])
      ])
    ], 2))
  }), 128))
}